import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { Col } from 'antd';
import './index.less';
import responsive from './responsive';

const Description = ({ term, column, children, ...restProps }) => (
  <Col {...responsive[column]} {...restProps}>
    {term && <div className="term">{term}</div>}
    {children !== null && children !== undefined && <div className="detail">{children}</div>}
  </Col>
);

Description.defaultProps = {
  term: '',
};

Description.propTypes = {
  term: PropTypes.node,
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/comm/DescriptionList/Description.js